import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 25 25",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-39.766 -126.894)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M50.3,142.4c0,0-1.5-0.5-1.5-3c-0.8,0-0.8-2,0-2c0-0.3-1.5-4,1-3.5c0.5-2,6-2,6.5,0 c0.3,1.4-0.5,3.3-0.5,3.5c0.8,0,0.8,2,0,2c0,2.5-1.5,3-1.5,3v2.5c2.5,0.9,4.9,1.7,6.2,2.6c4.5-4.5,4.4-11.8-0.1-16.3 s-11.8-4.4-16.3,0.1c-4.4,4.5-4.4,11.7,0,16.2c1.3-0.9,4-1.7,6.2-2.6V142.4z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.5px",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M44.1,147.5c4.5,4.5,11.7,4.6,16.3,0.1c0,0,0.1-0.1,0.1-0.1",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.5px",
			strokeLinejoin: "round"
		})]
	})
});
export { SvgSingleNeutralCircle as ReactComponent };
